import { createFileRoute } from '@tanstack/react-router'

import { ClientDetailPage } from '@/pages/clients/[id]/ClientDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/clients/$id/')({
  component: ClientDetailPage,
})
